module.exports = __webpack_public_path__ + "static/img/qualifications1.a17b9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qualifications1.png
// module id = jGwI
// module chunks = 1